import type {ReactElement} from 'react';
import {SkeletonBrick} from '@Components/skeleton-brick';
import {
  REEL_MUSIC_SKELETON_ARTWORK_SIZE_PX,
  REEL_MUSIC_SKELETON_DETAILS_WIDTH_PX,
  REEL_MUSIC_SKELETON_LINE_HEIGHT_PX,
  REEL_MUSIC_SKELETON_TITLE_WIDTH_PX,
  REEL_MUSIC_SKELETON_TRACK_COUNT,
} from './reel-music-track-list-skeleton.types';
import styles from './reel-music-track-list-skeleton.module.scss';

export function ReelMusicTrackListSkeleton(): ReactElement {
  const getSkeletonTrack = (index: number): ReactElement => {
    return (
      <div key={index} className={`${styles.skeletonTrack} flexbox align-items-center gap-2 spacing-p-1`}>
        <SkeletonBrick width={REEL_MUSIC_SKELETON_ARTWORK_SIZE_PX} height={REEL_MUSIC_SKELETON_ARTWORK_SIZE_PX} className="radius-8" />
        <div className="flexbox flex-column gap-2">
          <SkeletonBrick width={REEL_MUSIC_SKELETON_TITLE_WIDTH_PX} height={REEL_MUSIC_SKELETON_LINE_HEIGHT_PX} />
          <SkeletonBrick width={REEL_MUSIC_SKELETON_DETAILS_WIDTH_PX} height={REEL_MUSIC_SKELETON_LINE_HEIGHT_PX} />
        </div>
      </div>
    );
  };

  return (
    <div aria-busy="true" aria-label={window.i18next.t('pmwjs_loading')} className="flexbox flex-column gap-2 spacing-p-b-2">
      {Array.from({length: REEL_MUSIC_SKELETON_TRACK_COUNT}, (_, index) => getSkeletonTrack(index))}
    </div>
  );
}
